<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="profilesOfDocuments"
      :items="profilesOfDocuments"
      :fields="profilesOfDocumentsFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedProfilesOfDocumentsFields"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      profilesOfDocumentsFields: [
        {key: 'profile_id', label: this.$i18n.t('Profile ID'), sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'created', label: this.$i18n.t('Created'), sortable: true, formatter: (val, key, item) => { return val === 0 ? this.$i18n.t('Not installed') : this.$root.showDataWithTZDelta(val) }},
        {key: 'modified', label: this.$i18n.t('Modified'), sortable: true, formatter: (val, key, item) => { return val === 0 ? this.$i18n.t('Not installed') : this.$root.showDataWithTZDelta(val) }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedProfilesOfDocumentsFields: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedProfilesOfDocumentsFields = {
        profile_id: 0,
        name: '',
        templates: []
      }
      this.$root.$emit('bv::show::modal', 'modalEditProfilesOfDocuments', '#btnShow')
    },
    editItem (item) {
      this.selectedProfilesOfDocumentsFields = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditProfilesOfDocuments', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Profiles of documents"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_PROFILES_OF_DOCUMENTS', item.profile_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_PROFILES_OF_DOCUMENTS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    profilesOfDocuments () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/PROFILES_OF_DOCUMENTS']))
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_PROFILES_OF_DOCUMENTS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/documents/profilesOfDocuments/main.vue